
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewColumnDialog extends SiteEntityDialog<SummaryViewColumnRow, any> {
        protected getFormKey() { return SummaryViewColumnForm.formKey; }
        protected getIdProperty() { return SummaryViewColumnRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewColumnRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewColumnRow.nameProperty; }
        protected getService() { return SummaryViewColumnService.baseUrl; }

        protected form = new SummaryViewColumnForm(this.idPrefix);

    }
}